import React, { Component } from 'react';
import { timingSafeEqual } from 'crypto';

class CuartaLinea extends Component {
    constructor(props) {
        super(props);
        this.state={
            grabadoCuartaLinea:""
        }
    }

    handleChangeGrabado(value) {
        let validate = /^[a-záéíóúñÑÁÉÍÓÚ\-A-Z0-9\s]*$/.test(value)
        if (validate || value == ""){ 
            this.setState({ grabadoCuartaLinea: value },()=>this.props.onBlurTextBox("grabadoCuartaLinea", this.state.grabadoCuartaLinea));
        }
    }

    componentDidMount(){
        
    }

    componentWillReceiveProps(nextProps){
        
        if(nextProps.data.carteraId!=this.props.data.carteraId || nextProps.data.grupoAfinidadSeleccionadoId!=this.props.data.grupoAfinidadSeleccionadoId || nextProps.data.sucursalSeleccionadaId!=this.props.data.sucursalSeleccionadaId || nextProps.data.segmentoCarteraSeleccionadoId!=this.props.data.segmentoCarteraSeleccionadoId || nextProps.data.marcaCompartidaSeleccionadaId!=this.props.data.marcaCompartidaSeleccionadaId   ){
            if(this.props.tipoGrabado && this.props.tipoGrabado == "Texto"){
                if(this.props.data.GET_PRODUCTO_CABAL_PRODUCTO_ID) this.handleChangeGrabado(this.props.data.GET_PRODUCTO_CABAL_PRODUCTO_ID.TextoCuartaLinea)
            }else if(this.props.tipoGrabado && this.props.tipoGrabado != "Texto"){
                
                let valorCuartaLinea
                switch (this.props.tipoGrabado){
                    case "CicloFacturacion":{
                        if(nextProps.dataTarjetas && nextProps.dataTarjetas.carteraId && this.props.data.GET_CARTERAS_PRODUCTO.some(e=>e.Id==nextProps.dataTarjetas.carteraId)) valorCuartaLinea = this.props.data.GET_CARTERAS_PRODUCTO.filter(e=>e.Id==nextProps.dataTarjetas.carteraId)[0].Descripcion.split("- ")[1]  
                        break
                    }
                    case "GAF":{
                        if(nextProps.dataTarjetas && nextProps.dataTarjetas.grupoAfinidadSeleccionadoId && this.props.data.ATLAS_GRUPO_AFINIDAD.some(e=>e.Id==nextProps.dataTarjetas.grupoAfinidadSeleccionadoId)) valorCuartaLinea = this.props.data.ATLAS_GRUPO_AFINIDAD.filter(e=>e.Id==nextProps.dataTarjetas.grupoAfinidadSeleccionadoId)[0].Descripcion  
                        break
                    } 
                    case "Sucursal":{
                        if(nextProps.dataTarjetas && nextProps.dataTarjetas.sucursalSeleccionadaId && this.props.data.ATLAS_SUCURSALES.some(e=>e.Id==nextProps.dataTarjetas.sucursalSeleccionadaId)) valorCuartaLinea = this.props.data.ATLAS_SUCURSALES.filter(e=>e.Id==nextProps.dataTarjetas.sucursalSeleccionadaId)[0].Descripcion  
                        break
                    } 
                    case "Segmento":{
                        if(nextProps.dataTarjetas && nextProps.dataTarjetas.segmentoCarteraSeleccionadoId && this.props.data.ATLAS_SEGMENTO_CARTERA.some(e=>e.Id==nextProps.dataTarjetas.segmentoCarteraSeleccionadoId)) valorCuartaLinea = this.props.data.ATLAS_SEGMENTO_CARTERA.filter(e=>e.Id==nextProps.dataTarjetas.segmentoCarteraSeleccionadoId)[0].Descripcion  
                        break
                    } 
                    case "MarcaComp":{
                        if(nextProps.dataTarjetas && nextProps.dataTarjetas.marcaCompartidaSeleccionadaId && this.props.data.ATLAS_MARCA_COMPARTIDA.some(e=>e.Id==nextProps.dataTarjetas.marcaCompartidaSeleccionadaId)) valorCuartaLinea = this.props.data.ATLAS_MARCA_COMPARTIDA.filter(e=>e.Id==nextProps.dataTarjetas.marcaCompartidaSeleccionadaId)[0].Descripcion  
                        break
                    }
                    default: null
                }
                if(valorCuartaLinea){
                    valorCuartaLinea && this.setState({ grabadoCuartaLinea: valorCuartaLinea },()=>this.props.onBlurTextBox("grabadoCuartaLinea", valorCuartaLinea));
                }
            }
        }        
    }
    
    render() {
       
        return (
            <div>
                <input className="form-control default-select" placeholder={"Ingrese un Grabado de Cuarta Línea..."} value={this.state.grabadoCuartaLinea} onChange={e=>this.handleChangeGrabado(e.target.value)} type="text" maxLength="40"></input>
            </div>
        );
    }
}

export default CuartaLinea;